import { render, staticRenderFns } from "./AnnotationsList.vue?vue&type=template&id=b10abd14&scoped=true&"
import script from "./AnnotationsList.vue?vue&type=script&lang=js&"
export * from "./AnnotationsList.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsList.vue?vue&type=style&index=0&id=b10abd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10abd14",
  null
  
)

export default component.exports